module.exports = __webpack_public_path__ + "static/fipcpinkcloud1-e4e7aff362edd83fa6fecc4e713275ba.jpeg";